import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const applicationSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  context_id: required({ t })(Yup.string())
})

export default applicationSchema
